import { Observable, observe, Scope } from 'src/3rds/cube'

@Observable
export class WaitingScope extends Scope {
    @observe() text = ''
}
